import { NeighborhoodComuna } from '../interfaces/Location/Location'

export const cities: NeighborhoodComuna[] = [
  { cityId: 11, neighborhoodId: 1101, name: 'Iquique' },
  { cityId: 11, neighborhoodId: 1107, name: 'Alto Hospicio' },
  { cityId: 14, neighborhoodId: 1401, name: 'Pozo Almonte' },
  { cityId: 14, neighborhoodId: 1402, name: 'Camiña' },
  { cityId: 14, neighborhoodId: 1403, name: 'Colchane' },
  { cityId: 14, neighborhoodId: 1404, name: 'Huara' },
  { cityId: 14, neighborhoodId: 1405, name: 'Pica' },
  { cityId: 21, neighborhoodId: 2101, name: 'Antofagasta' },
  { cityId: 21, neighborhoodId: 2102, name: 'Mejillones' },
  { cityId: 21, neighborhoodId: 2103, name: 'Sierra Gorda' },
  { cityId: 21, neighborhoodId: 2104, name: 'Taltal' },
  { cityId: 22, neighborhoodId: 2201, name: 'Calama' },
  { cityId: 22, neighborhoodId: 2202, name: 'Ollagüe' },
  { cityId: 22, neighborhoodId: 2203, name: 'San Pedro de Atacama' },
  { cityId: 23, neighborhoodId: 2301, name: 'Tocopilla' },
  { cityId: 23, neighborhoodId: 2302, name: 'María Elena' },
  { cityId: 31, neighborhoodId: 3101, name: 'Copiapó' },
  { cityId: 31, neighborhoodId: 3102, name: 'Caldera' },
  { cityId: 31, neighborhoodId: 3103, name: 'Tierra Amarilla' },
  { cityId: 32, neighborhoodId: 3201, name: 'Chañaral' },
  { cityId: 32, neighborhoodId: 3202, name: 'Diego de Almagro' },
  { cityId: 33, neighborhoodId: 3301, name: 'Vallenar' },
  { cityId: 33, neighborhoodId: 3302, name: 'Alto del Carmen' },
  { cityId: 33, neighborhoodId: 3303, name: 'Freirina' },
  { cityId: 33, neighborhoodId: 3304, name: 'Huasco' },
  { cityId: 41, neighborhoodId: 4101, name: 'La Serena' },
  { cityId: 41, neighborhoodId: 4102, name: 'Coquimbo' },
  { cityId: 41, neighborhoodId: 4103, name: 'Andacollo' },
  { cityId: 41, neighborhoodId: 4104, name: 'La Higuera' },
  { cityId: 41, neighborhoodId: 4105, name: 'Paiguano' },
  { cityId: 41, neighborhoodId: 4106, name: 'Vicuña' },
  { cityId: 42, neighborhoodId: 4201, name: 'Illapel' },
  { cityId: 42, neighborhoodId: 4202, name: 'Canela' },
  { cityId: 42, neighborhoodId: 4203, name: 'Los Vilos' },
  { cityId: 42, neighborhoodId: 4204, name: 'Salamanca' },
  { cityId: 43, neighborhoodId: 4301, name: 'Ovalle' },
  { cityId: 43, neighborhoodId: 4302, name: 'Combarbalá' },
  { cityId: 43, neighborhoodId: 4303, name: 'Monte Patria' },
  { cityId: 43, neighborhoodId: 4304, name: 'Punitaqui' },
  { cityId: 43, neighborhoodId: 4305, name: 'Río Hurtado' },
  { cityId: 51, neighborhoodId: 5101, name: 'Valparaíso' },
  { cityId: 51, neighborhoodId: 5102, name: 'Casablanca' },
  { cityId: 51, neighborhoodId: 5103, name: 'Concón' },
  { cityId: 51, neighborhoodId: 5104, name: 'Juan Fernández' },
  { cityId: 51, neighborhoodId: 5105, name: 'Puchuncaví' },
  { cityId: 51, neighborhoodId: 5107, name: 'Quintero' },
  { cityId: 51, neighborhoodId: 5109, name: 'Viña del Mar' },
  { cityId: 52, neighborhoodId: 5201, name: 'Isla de Pascua' },
  { cityId: 53, neighborhoodId: 5301, name: 'Los Andes' },
  { cityId: 53, neighborhoodId: 5302, name: 'Calle Larga' },
  { cityId: 53, neighborhoodId: 5303, name: 'Rinconada' },
  { cityId: 53, neighborhoodId: 5304, name: 'San Esteban' },
  { cityId: 54, neighborhoodId: 5401, name: 'La Ligua' },
  { cityId: 54, neighborhoodId: 5402, name: 'Cabildo' },
  { cityId: 54, neighborhoodId: 5403, name: 'Papudo' },
  { cityId: 54, neighborhoodId: 5404, name: 'Petorca' },
  { cityId: 54, neighborhoodId: 5405, name: 'Zapallar' },
  { cityId: 55, neighborhoodId: 5501, name: 'Quillota' },
  { cityId: 55, neighborhoodId: 5502, name: 'Calera' },
  { cityId: 55, neighborhoodId: 5503, name: 'Hijuelas' },
  { cityId: 55, neighborhoodId: 5504, name: 'La Cruz' },
  { cityId: 55, neighborhoodId: 5506, name: 'Nogales' },
  { cityId: 56, neighborhoodId: 5601, name: 'San Antonio' },
  { cityId: 56, neighborhoodId: 5602, name: 'Algarrobo' },
  { cityId: 56, neighborhoodId: 5603, name: 'Cartagena' },
  { cityId: 56, neighborhoodId: 5604, name: 'El Quisco' },
  { cityId: 56, neighborhoodId: 5605, name: 'El Tabo' },
  { cityId: 56, neighborhoodId: 5606, name: 'Santo Domingo' },
  { cityId: 57, neighborhoodId: 5701, name: 'San Felipe' },
  { cityId: 57, neighborhoodId: 5702, name: 'Catemu' },
  { cityId: 57, neighborhoodId: 5703, name: 'Llaillay' },
  { cityId: 57, neighborhoodId: 5704, name: 'Panquehue' },
  { cityId: 57, neighborhoodId: 5705, name: 'Putaendo' },
  { cityId: 57, neighborhoodId: 5706, name: 'Santa María' },
  { cityId: 58, neighborhoodId: 5801, name: 'Quilpué' },
  { cityId: 58, neighborhoodId: 5802, name: 'Limache' },
  { cityId: 58, neighborhoodId: 5803, name: 'Olmué' },
  { cityId: 58, neighborhoodId: 5804, name: 'Villa Alemana' },
  { cityId: 61, neighborhoodId: 6101, name: 'Rancagua' },
  { cityId: 61, neighborhoodId: 6102, name: 'Codegua' },
  { cityId: 61, neighborhoodId: 6103, name: 'Coinco' },
  { cityId: 61, neighborhoodId: 6104, name: 'Coltauco' },
  { cityId: 61, neighborhoodId: 6105, name: 'Doñihue' },
  { cityId: 61, neighborhoodId: 6106, name: 'Graneros' },
  { cityId: 61, neighborhoodId: 6107, name: 'Las Cabras' },
  { cityId: 61, neighborhoodId: 6108, name: 'Machalí' },
  { cityId: 61, neighborhoodId: 6109, name: 'Malloa' },
  { cityId: 61, neighborhoodId: 6110, name: 'Mostazal' },
  { cityId: 61, neighborhoodId: 6111, name: 'Olivar' },
  { cityId: 61, neighborhoodId: 6112, name: 'Peumo' },
  { cityId: 61, neighborhoodId: 6113, name: 'Pichidegua' },
  { cityId: 61, neighborhoodId: 6114, name: 'Quinta de Tilcoco' },
  { cityId: 61, neighborhoodId: 6115, name: 'Rengo' },
  { cityId: 61, neighborhoodId: 6116, name: 'Requínoa' },
  { cityId: 61, neighborhoodId: 6117, name: 'San Vicente' },
  { cityId: 62, neighborhoodId: 6201, name: 'Pichilemu' },
  { cityId: 62, neighborhoodId: 6202, name: 'La Estrella' },
  { cityId: 62, neighborhoodId: 6203, name: 'Litueche' },
  { cityId: 62, neighborhoodId: 6204, name: 'Marchihue' },
  { cityId: 62, neighborhoodId: 6205, name: 'Navidad' },
  { cityId: 62, neighborhoodId: 6206, name: 'Paredones' },
  { cityId: 63, neighborhoodId: 6301, name: 'San Fernando' },
  { cityId: 63, neighborhoodId: 6302, name: 'Chépica' },
  { cityId: 63, neighborhoodId: 6303, name: 'Chimbarongo' },
  { cityId: 63, neighborhoodId: 6304, name: 'Lolol' },
  { cityId: 63, neighborhoodId: 6305, name: 'Nancagua' },
  { cityId: 63, neighborhoodId: 6306, name: 'Palmilla' },
  { cityId: 63, neighborhoodId: 6307, name: 'Peralillo' },
  { cityId: 63, neighborhoodId: 6308, name: 'Placilla' },
  { cityId: 63, neighborhoodId: 6309, name: 'Pumanque' },
  { cityId: 63, neighborhoodId: 6310, name: 'Santa Cruz' },
  { cityId: 71, neighborhoodId: 7101, name: 'Talca' },
  { cityId: 71, neighborhoodId: 7102, name: 'Constitución' },
  { cityId: 71, neighborhoodId: 7103, name: 'Curepto' },
  { cityId: 71, neighborhoodId: 7104, name: 'Empedrado' },
  { cityId: 71, neighborhoodId: 7105, name: 'Maule' },
  { cityId: 71, neighborhoodId: 7106, name: 'Pelarco' },
  { cityId: 71, neighborhoodId: 7107, name: 'Pencahue' },
  { cityId: 71, neighborhoodId: 7108, name: 'Río Claro' },
  { cityId: 71, neighborhoodId: 7109, name: 'San Clemente' },
  { cityId: 71, neighborhoodId: 7110, name: 'San Rafael' },
  { cityId: 72, neighborhoodId: 7201, name: 'Cauquenes' },
  { cityId: 72, neighborhoodId: 7202, name: 'Chanco' },
  { cityId: 72, neighborhoodId: 7203, name: 'Pelluhue' },
  { cityId: 73, neighborhoodId: 7301, name: 'Curicó' },
  { cityId: 73, neighborhoodId: 7302, name: 'Hualañé' },
  { cityId: 73, neighborhoodId: 7303, name: 'Licantén' },
  { cityId: 73, neighborhoodId: 7304, name: 'Molina' },
  { cityId: 73, neighborhoodId: 7305, name: 'Rauco' },
  { cityId: 73, neighborhoodId: 7306, name: 'Romeral' },
  { cityId: 73, neighborhoodId: 7307, name: 'Sagrada Familia' },
  { cityId: 73, neighborhoodId: 7308, name: 'Teno' },
  { cityId: 73, neighborhoodId: 7309, name: 'Vichuquén' },
  { cityId: 74, neighborhoodId: 7401, name: 'Linares' },
  { cityId: 74, neighborhoodId: 7402, name: 'Colbún' },
  { cityId: 74, neighborhoodId: 7403, name: 'Longaví' },
  { cityId: 74, neighborhoodId: 7404, name: 'Parral' },
  { cityId: 74, neighborhoodId: 7405, name: 'Retiro' },
  { cityId: 74, neighborhoodId: 7406, name: 'San Javier' },
  { cityId: 74, neighborhoodId: 7407, name: 'Villa Alegre' },
  { cityId: 74, neighborhoodId: 7408, name: 'Yerbas Buenas' },
  { cityId: 81, neighborhoodId: 8101, name: 'Concepción' },
  { cityId: 81, neighborhoodId: 8102, name: 'Coronel' },
  { cityId: 81, neighborhoodId: 8103, name: 'Chiguayante' },
  { cityId: 81, neighborhoodId: 8104, name: 'Florida' },
  { cityId: 81, neighborhoodId: 8105, name: 'Hualqui' },
  { cityId: 81, neighborhoodId: 8106, name: 'Lota' },
  { cityId: 81, neighborhoodId: 8107, name: 'Penco' },
  { cityId: 81, neighborhoodId: 8108, name: 'San Pedro de la Paz' },
  { cityId: 81, neighborhoodId: 8109, name: 'Santa Juana' },
  { cityId: 81, neighborhoodId: 8110, name: 'Talcahuano' },
  { cityId: 81, neighborhoodId: 8111, name: 'Tomé' },
  { cityId: 81, neighborhoodId: 8112, name: 'Hualpén' },
  { cityId: 82, neighborhoodId: 8201, name: 'Lebu' },
  { cityId: 82, neighborhoodId: 8202, name: 'Arauco' },
  { cityId: 82, neighborhoodId: 8203, name: 'Cañete' },
  { cityId: 82, neighborhoodId: 8204, name: 'Contulmo' },
  { cityId: 82, neighborhoodId: 8205, name: 'Curanilahue' },
  { cityId: 82, neighborhoodId: 8206, name: 'Los Alamos' },
  { cityId: 82, neighborhoodId: 8207, name: 'Tirúa' },
  { cityId: 83, neighborhoodId: 8301, name: 'Los Angeles' },
  { cityId: 83, neighborhoodId: 8302, name: 'Antuco' },
  { cityId: 83, neighborhoodId: 8303, name: 'Cabrero' },
  { cityId: 83, neighborhoodId: 8304, name: 'Laja' },
  { cityId: 83, neighborhoodId: 8305, name: 'Mulchén' },
  { cityId: 83, neighborhoodId: 8306, name: 'Nacimiento' },
  { cityId: 83, neighborhoodId: 8307, name: 'Negrete' },
  { cityId: 83, neighborhoodId: 8308, name: 'Quilaco' },
  { cityId: 83, neighborhoodId: 8309, name: 'Quilleco' },
  { cityId: 83, neighborhoodId: 8310, name: 'San Rosendo' },
  { cityId: 83, neighborhoodId: 8311, name: 'Santa Bárbara' },
  { cityId: 83, neighborhoodId: 8312, name: 'Tucapel' },
  { cityId: 83, neighborhoodId: 8313, name: 'Yumbel' },
  { cityId: 83, neighborhoodId: 8314, name: 'Alto Biobío' },
  { cityId: 91, neighborhoodId: 9101, name: 'Temuco' },
  { cityId: 91, neighborhoodId: 9102, name: 'Carahue' },
  { cityId: 91, neighborhoodId: 9103, name: 'Cunco' },
  { cityId: 91, neighborhoodId: 9104, name: 'Curarrehue' },
  { cityId: 91, neighborhoodId: 9105, name: 'Freire' },
  { cityId: 91, neighborhoodId: 9106, name: 'Galvarino' },
  { cityId: 91, neighborhoodId: 9107, name: 'Gorbea' },
  { cityId: 91, neighborhoodId: 9108, name: 'Lautaro' },
  { cityId: 91, neighborhoodId: 9109, name: 'Loncoche' },
  { cityId: 91, neighborhoodId: 9110, name: 'Melipeuco' },
  { cityId: 91, neighborhoodId: 9111, name: 'Nueva Imperial' },
  { cityId: 91, neighborhoodId: 9112, name: 'Padre Las Casas' },
  { cityId: 91, neighborhoodId: 9113, name: 'Perquenco' },
  { cityId: 91, neighborhoodId: 9114, name: 'Pitrufquén' },
  { cityId: 91, neighborhoodId: 9115, name: 'Pucón' },
  { cityId: 91, neighborhoodId: 9116, name: 'Saavedra' },
  { cityId: 91, neighborhoodId: 9117, name: 'Teodoro Schmidt' },
  { cityId: 91, neighborhoodId: 9118, name: 'Toltén' },
  { cityId: 91, neighborhoodId: 9119, name: 'Vilcún' },
  { cityId: 91, neighborhoodId: 9120, name: 'Villarrica' },
  { cityId: 91, neighborhoodId: 9121, name: 'Cholchol' },
  { cityId: 92, neighborhoodId: 9201, name: 'Angol' },
  { cityId: 92, neighborhoodId: 9202, name: 'Collipulli' },
  { cityId: 92, neighborhoodId: 9203, name: 'Curacautín' },
  { cityId: 92, neighborhoodId: 9204, name: 'Ercilla' },
  { cityId: 92, neighborhoodId: 9205, name: 'Lonquimay' },
  { cityId: 92, neighborhoodId: 9206, name: 'Los Sauces' },
  { cityId: 92, neighborhoodId: 9207, name: 'Lumaco' },
  { cityId: 92, neighborhoodId: 9208, name: 'Purén' },
  { cityId: 92, neighborhoodId: 9209, name: 'Renaico' },
  { cityId: 92, neighborhoodId: 9210, name: 'Traiguén' },
  { cityId: 92, neighborhoodId: 9211, name: 'Victoria' },
  { cityId: 101, neighborhoodId: 10101, name: 'Puerto Montt' },
  { cityId: 101, neighborhoodId: 10102, name: 'Calbuco' },
  { cityId: 101, neighborhoodId: 10103, name: 'Cochamó' },
  { cityId: 101, neighborhoodId: 10104, name: 'Fresia' },
  { cityId: 101, neighborhoodId: 10105, name: 'Frutillar' },
  { cityId: 101, neighborhoodId: 10106, name: 'Los Muermos' },
  { cityId: 101, neighborhoodId: 10107, name: 'Llanquihue' },
  { cityId: 101, neighborhoodId: 10108, name: 'Maullín' },
  { cityId: 101, neighborhoodId: 10109, name: 'Puerto Varas' },
  { cityId: 102, neighborhoodId: 10201, name: 'Castro' },
  { cityId: 102, neighborhoodId: 10202, name: 'Ancud' },
  { cityId: 102, neighborhoodId: 10203, name: 'Chonchi' },
  { cityId: 102, neighborhoodId: 10204, name: 'Curaco de Vélez' },
  { cityId: 102, neighborhoodId: 10205, name: 'Dalcahue' },
  { cityId: 102, neighborhoodId: 10206, name: 'Puqueldón' },
  { cityId: 102, neighborhoodId: 10207, name: 'Queilén' },
  { cityId: 102, neighborhoodId: 10208, name: 'Quellón' },
  { cityId: 102, neighborhoodId: 10209, name: 'Quemchi' },
  { cityId: 102, neighborhoodId: 10210, name: 'Quinchao' },
  { cityId: 103, neighborhoodId: 10301, name: 'Osorno' },
  { cityId: 103, neighborhoodId: 10302, name: 'Puerto Octay' },
  { cityId: 103, neighborhoodId: 10303, name: 'Purranque' },
  { cityId: 103, neighborhoodId: 10304, name: 'Puyehue' },
  { cityId: 103, neighborhoodId: 10305, name: 'Río Negro' },
  { cityId: 103, neighborhoodId: 10306, name: 'San Juan de la Costa' },
  { cityId: 103, neighborhoodId: 10307, name: 'San Pablo' },
  { cityId: 104, neighborhoodId: 10401, name: 'Chaitén' },
  { cityId: 104, neighborhoodId: 10402, name: 'Futaleufú' },
  { cityId: 104, neighborhoodId: 10403, name: 'Hualaihué' },
  { cityId: 104, neighborhoodId: 10404, name: 'Palena' },
  { cityId: 111, neighborhoodId: 11101, name: 'Coihaique' },
  { cityId: 111, neighborhoodId: 11102, name: 'Lago Verde' },
  { cityId: 112, neighborhoodId: 11201, name: 'Aisén' },
  { cityId: 112, neighborhoodId: 11202, name: 'Cisnes' },
  { cityId: 112, neighborhoodId: 11203, name: 'Guaitecas' },
  { cityId: 113, neighborhoodId: 11301, name: 'Cochrane' },
  { cityId: 113, neighborhoodId: 11302, name: 'O`Higgins' },
  { cityId: 113, neighborhoodId: 11303, name: 'Tortel' },
  { cityId: 114, neighborhoodId: 11401, name: 'Chile Chico' },
  { cityId: 114, neighborhoodId: 11402, name: 'Río Ibáñez' },
  { cityId: 121, neighborhoodId: 12101, name: 'Punta Arenas' },
  { cityId: 121, neighborhoodId: 12102, name: 'Laguna Blanca' },
  { cityId: 121, neighborhoodId: 12103, name: 'Río Verde' },
  { cityId: 121, neighborhoodId: 12104, name: 'San Gregorio' },
  { cityId: 122, neighborhoodId: 12201, name: 'Cabo de Hornos' },
  { cityId: 122, neighborhoodId: 12202, name: 'Antártica' },
  { cityId: 123, neighborhoodId: 12301, name: 'Porvenir' },
  { cityId: 123, neighborhoodId: 12302, name: 'Primavera' },
  { cityId: 123, neighborhoodId: 12303, name: 'Timaukel' },
  { cityId: 124, neighborhoodId: 12401, name: 'Natales' },
  { cityId: 124, neighborhoodId: 12402, name: 'Torres del Paine' },
  { cityId: 131, neighborhoodId: 13101, name: 'Santiago' },
  { cityId: 131, neighborhoodId: 13102, name: 'Cerrillos' },
  { cityId: 131, neighborhoodId: 13103, name: 'Cerro Navia' },
  { cityId: 131, neighborhoodId: 13104, name: 'Conchalí' },
  { cityId: 131, neighborhoodId: 13105, name: 'El Bosque' },
  { cityId: 131, neighborhoodId: 13106, name: 'Estación Central' },
  { cityId: 131, neighborhoodId: 13107, name: 'Huechuraba' },
  { cityId: 131, neighborhoodId: 13108, name: 'Independencia' },
  { cityId: 131, neighborhoodId: 13109, name: 'La Cisterna' },
  { cityId: 131, neighborhoodId: 13110, name: 'La Florida' },
  { cityId: 131, neighborhoodId: 13111, name: 'La Granja' },
  { cityId: 131, neighborhoodId: 13112, name: 'La Pintana' },
  { cityId: 131, neighborhoodId: 13113, name: 'La Reina' },
  { cityId: 131, neighborhoodId: 13114, name: 'Las Condes' },
  { cityId: 131, neighborhoodId: 13115, name: 'Lo Barnechea' },
  { cityId: 131, neighborhoodId: 13116, name: 'Lo Espejo' },
  { cityId: 131, neighborhoodId: 13117, name: 'Lo Prado' },
  { cityId: 131, neighborhoodId: 13118, name: 'Macul' },
  { cityId: 131, neighborhoodId: 13119, name: 'Maipú' },
  { cityId: 131, neighborhoodId: 13120, name: 'Ñuñoa' },
  { cityId: 131, neighborhoodId: 13121, name: 'Pedro Aguirre Cerda' },
  { cityId: 131, neighborhoodId: 13122, name: 'Peñalolén' },
  { cityId: 131, neighborhoodId: 13123, name: 'Providencia' },
  { cityId: 131, neighborhoodId: 13124, name: 'Pudahuel' },
  { cityId: 131, neighborhoodId: 13125, name: 'Quilicura' },
  { cityId: 131, neighborhoodId: 13126, name: 'Quinta Normal' },
  { cityId: 131, neighborhoodId: 13127, name: 'Recoleta' },
  { cityId: 131, neighborhoodId: 13128, name: 'Renca' },
  { cityId: 131, neighborhoodId: 13129, name: 'San Joaquín' },
  { cityId: 131, neighborhoodId: 13130, name: 'San Miguel' },
  { cityId: 131, neighborhoodId: 13131, name: 'San Ramón' },
  { cityId: 131, neighborhoodId: 13132, name: 'Vitacura' },
  { cityId: 132, neighborhoodId: 13201, name: 'Puente Alto' },
  { cityId: 132, neighborhoodId: 13202, name: 'Pirque' },
  { cityId: 132, neighborhoodId: 13203, name: 'San José de Maipo' },
  { cityId: 133, neighborhoodId: 13301, name: 'Colina' },
  { cityId: 133, neighborhoodId: 13302, name: 'Lampa' },
  { cityId: 133, neighborhoodId: 13303, name: 'Tiltil' },
  { cityId: 134, neighborhoodId: 13401, name: 'San Bernardo' },
  { cityId: 134, neighborhoodId: 13402, name: 'Buin' },
  { cityId: 134, neighborhoodId: 13403, name: 'Calera de Tango' },
  { cityId: 134, neighborhoodId: 13404, name: 'Paine' },
  { cityId: 135, neighborhoodId: 13501, name: 'Melipilla' },
  { cityId: 135, neighborhoodId: 13502, name: 'Alhué' },
  { cityId: 135, neighborhoodId: 13503, name: 'Curacaví' },
  { cityId: 135, neighborhoodId: 13504, name: 'María Pinto' },
  { cityId: 135, neighborhoodId: 13505, name: 'San Pedro' },
  { cityId: 136, neighborhoodId: 13601, name: 'Talagante' },
  { cityId: 136, neighborhoodId: 13602, name: 'El Monte' },
  { cityId: 136, neighborhoodId: 13603, name: 'Isla de Maipo' },
  { cityId: 136, neighborhoodId: 13604, name: 'Padre Hurtado' },
  { cityId: 136, neighborhoodId: 13605, name: 'Peñaflor' },
  { cityId: 141, neighborhoodId: 14101, name: 'Valdivia' },
  { cityId: 141, neighborhoodId: 14102, name: 'Corral' },
  { cityId: 141, neighborhoodId: 14103, name: 'Lanco' },
  { cityId: 141, neighborhoodId: 14104, name: 'Los Lagos' },
  { cityId: 141, neighborhoodId: 14105, name: 'Máfil' },
  { cityId: 141, neighborhoodId: 14106, name: 'Mariquina' },
  { cityId: 141, neighborhoodId: 14107, name: 'Paillaco' },
  { cityId: 141, neighborhoodId: 14108, name: 'Panguipulli' },
  { cityId: 142, neighborhoodId: 14201, name: 'La Unión' },
  { cityId: 142, neighborhoodId: 14202, name: 'Futrono' },
  { cityId: 142, neighborhoodId: 14203, name: 'Lago Ranco' },
  { cityId: 142, neighborhoodId: 14204, name: 'Río Bueno' },
  { cityId: 151, neighborhoodId: 15101, name: 'Arica' },
  { cityId: 151, neighborhoodId: 15102, name: 'Camarones' },
  { cityId: 152, neighborhoodId: 15201, name: 'Putre' },
  { cityId: 152, neighborhoodId: 15202, name: 'General Lagos' },
  { cityId: 161, neighborhoodId: 16101, name: 'Chillán' },
  { cityId: 161, neighborhoodId: 16102, name: 'Bulnes' },
  { cityId: 161, neighborhoodId: 16103, name: 'Chillán Viejo' },
  { cityId: 161, neighborhoodId: 16104, name: 'El Carmen' },
  { cityId: 161, neighborhoodId: 16105, name: 'Pemuco' },
  { cityId: 161, neighborhoodId: 16106, name: 'Pinto' },
  { cityId: 161, neighborhoodId: 16107, name: 'Quillón' },
  { cityId: 161, neighborhoodId: 16108, name: 'San Ignacio' },
  { cityId: 161, neighborhoodId: 16109, name: 'Yungay' },
  { cityId: 162, neighborhoodId: 16201, name: 'Quirihue' },
  { cityId: 162, neighborhoodId: 16202, name: 'Cobquecura' },
  { cityId: 162, neighborhoodId: 16203, name: 'Coelemu' },
  { cityId: 162, neighborhoodId: 16204, name: 'Ninhue' },
  { cityId: 162, neighborhoodId: 16205, name: 'Portezuelo' },
  { cityId: 162, neighborhoodId: 16206, name: 'Ranquil' },
  { cityId: 162, neighborhoodId: 16207, name: 'Treguaco' },
  { cityId: 163, neighborhoodId: 16301, name: 'San Carlos' },
  { cityId: 163, neighborhoodId: 16302, name: 'Coihueco' },
  { cityId: 163, neighborhoodId: 16303, name: 'Ñiquén' },
  { cityId: 163, neighborhoodId: 16304, name: 'San Fabián' },
  { cityId: 163, neighborhoodId: 16305, name: 'San Nicolás' }
]
